import React, { Component } from 'react';
import './GameList.css';
import './AlternateGameList.css';
import { LazyImageWithBox, LazyImageWithBox2 } from "./opinionatedComponents";
import {getExtension, APIPath} from '../utils/GlobalConsts';

export class GameList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      games: [],
      sortedGames: [],
      isLoading: false,
      error: null
    };
    this.filterGames = this.filterGames.bind(this);
  }

  filterGames() {
    let dispGames = [];
    dispGames = this.state.games.filter(game => this.gameMeetsFilter(game) && this.gameMeetsMaturity(game) && (this.props.secretVisible ? true : game.active));

    return dispGames;
  }

  gameMeetsFilter(game) {
    const filterArr = this.props.filters;
    //check if single or multi player
    if ((filterArr.players === 'single' && game.max_players !== 1)
      || (filterArr.players === 'multi' && game.max_players === 1))
      return false;

    //if multi/single player options match, and genres empty
    if (filterArr.genres === "all") {
      return true;
    }

    //now check for genres and select only those which have a matching genre
    if (game.genres.some(genre => filterArr.genres === genre))
      return true;

    //if nothing found
    return false;
  }

  gameMeetsMaturity(game) {
    if (this.props.filters.maturity === "allAges") {
      return true;
    } else if (this.props.filters.maturity === "child" && game.mature === false) {
      return true;
    } else if (this.props.filters.maturity === "adult" && game.mature === true) {
      return true;
    }
    //if none of conditions satisfied, eliminate this game
    return false;
  }

  componentDidMount() {
    let location = 1;

    if(this.props.matchFunc !== undefined
      && this.props.matchFunc.params.location !== undefined
      && (this.props.matchFunc.params.location.match("[0-9]+") !== null || this.props.matchFunc.params.location.match("[a-z-]+") !== null)
    ) {
        location = this.props.matchFunc.params.location;
    }

    const API = `${APIPath()}/api/corp/getPublicGamesFromLocation/` + location;

    fetch(API)
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error('Something went wrong ...');
        }
      })
      .then(data => {
        this.setState({ games: data , displayGames: data, isLoading: false});
      })
      .catch(error => this.setState({ error, isLoading: false }));

      window.addEventListener("resize", this.adjustOverlayHeights);
  }

  getNumCols(numCols) {
    switch (numCols) {
      case "1":
        return "col1";
      case "2":
        return "col2";
      case "3":
        return "col3";
      case "4":
        return "col4";
      case "5":
        return "col5";
      case "6":
        return "col6";
      case "7":
        return "col7";
      case "8":
        return "col8";
      case "9":
        return "col9";
      case "10":
        return "col10";
      case "11":
        return "col11";
      case "12":
        return "col12";
      case "13":
        return "col13";
      case "14":
        return "col14";
      case "15":
        return "col15";
      case "16":
        return "col16";
      default:
        return "defaultCols";
    }
  }

  tryAddImageExtension(path){
    if(!path) return path;
    if(path.match(".*game_images.*") !== null){
      if(path.match("\\.jpe?g") !== null){
        return path;
      }
      else{
        return path + ".jpg";
      }
    }
    else if(path.match("\\.(png|jpe?g)") !== null){
      //console.log("Old Age Format: ", path);
      const pathNoExtension = path.substring(0, path.lastIndexOf('.'));
      return pathNoExtension+ "." +getExtension();
    }
    else if(path.match("\\.(webp|jpg?2)") !== null){
      //console.log("New Age Format: ", path);
      return path;
    }
    else if(path.match("\\..+") === null){
      //console.log("Without extension: ", path);
      return path + "." + getExtension();
    }
    else{
      //console.log("Default:",path);
      return path + "." + getExtension();
    }
  }

  getGridView(displayGames, scrollSettings, gridContainer, colslet, scroll = "scroll", noScroll = "not-scroll") {
    console.log("Games:", displayGames);
    return (
      <div className={(scrollSettings) ? gridContainer + " " + scroll : gridContainer + " " + noScroll} >
        <div className={"pics " + colslet}>
          <ul>
            {displayGames.map(game =>
              <li key={game.game_identifier} id="grid-item">
                <div className="cont">
                  <LazyImageWithBox2
                    src={this.tryAddImageExtension(game.game_logo)} alt={game.name} />
                  <a href={game.game_url_prefix + game.portfolio_url} aria-label={game.name} rel="noopener noreferrer" target="_blank"> <div className="over"></div> </a>
                </div>
              </li>
            )}
          </ul>
        </div>
      </div>
    );
  }

  getDefaultView(displayGames, scrollSettings, gridContainer, scroll = "scroll", noScroll = "not-scroll") {
    console.log("Games:", displayGames);
    return (
      <div className={(scrollSettings) ? gridContainer + " " + scroll : gridContainer + " " + noScroll} >
        <div className="pictures">
          <ul>
            {displayGames.map(game =>
              <li key={game.game_identifier} id="grid-item">
                <div className="container">
                  <LazyImageWithBox
                    src={this.tryAddImageExtension(game.game_logo)} alt={game.name} />
                  <a href={game.game_url_prefix + game.portfolio_url} aria-label={game.name} rel="noopener noreferrer" target="_blank">
                    <div className={game.active ? "overlay" : "overlay-green"}> {this.props.secretVisible ? (game.active ? "ACTIVE" : "SECRET") : ""} </div> </a>
                </div>
              </li>
            )}
          </ul>
        </div>
      </div>
    );
  }

  componentDidUpdate() {
    this.adjustOverlayHeights();
  }

  adjustOverlayHeights() {
    let containers = document.getElementsByClassName("cont");
    if (containers.length !== 0) {
      let imgWidth = containers[0].clientWidth;
      let overlayHeight = imgWidth * 0.467;
      let overlays = document.getElementsByClassName("over");
      for (let i=0; i<overlays.length; i++) {
        overlays[i].style.height = overlayHeight + "px";
      }
    } else {
      containers = document.getElementsByClassName("container");
      if (containers.length !== 0) {
        let overlays = document.getElementsByClassName("overlay");
        for (let i=0; i<overlays.length; i++) {
          overlays[i].style.height = "100%";
        }
      }
    }
  }

  sortGames(displayGames, sortOption) {
    let sortedGames = displayGames;
    if (sortOption === "alpha") {
      sortedGames = displayGames.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase())? 1 : -1);
    } else if (sortOption === "reverse-alpha") {
      sortedGames = displayGames.sort((a, b) => (a.name.toLowerCase() < b.name.toLowerCase())? 1 : -1);
    } else if (sortOption === "numPlayersAsc") {
      sortedGames = displayGames.sort((a, b) => (a.max_players > b.max_players)? 1 : -1);
    } else if (sortOption === "numPlayersDesc") {
      sortedGames = displayGames.sort((a, b) => (a.max_players < b.max_players)? 1 : -1);
    }

    return sortedGames;
  }

  render() {
    this.adjustOverlayHeights();
    const isLoading = this.state.isLoading;
    const error = this.state.error;
    if (error) {
      console.log(error);
      return <p>{error.message}</p>;
    }
    if (isLoading) {
      return <p>Loading ...</p>;
    }

    let displayGames = this.filterGames();
    if (displayGames.length === 0) {
      return (
        <div>
          <p> There are Currently No Games Satisfying Your Criteria </p>
        </div>
      )
    }

    //check if not iframe to apply new styling - scroll bar
    let gridContainer = (window.self === window.top) ? "iframe-grid" : "grid-container";
    gridContainer = (this.props.settings.tableToggle) ? "min-grid" : gridContainer;
    gridContainer = (this.props.settings.selectionsToggle) ? gridContainer : "display-grid";

    let scrollSettings = true;
    if (this.props.settings.scrollToggle === true) {
      scrollSettings = true;
    } else {
      scrollSettings = false;
    }


    //display container
    let sortedGames, display;

    //if table options are selected
    if (this.props.tableFormat.cols !== "Default") {
      let colslet = this.getNumCols(this.props.tableFormat.cols);
      //sort the games
      sortedGames = this.sortGames(displayGames, this.props.sortOption);
      display = this.getGridView(sortedGames, scrollSettings, gridContainer, colslet);
      return display;
    } else {
      sortedGames = this.sortGames(displayGames, this.props.sortOption);
      display = this.getDefaultView(sortedGames, scrollSettings, gridContainer);
      return display;
    }

  }
}

export default GameList;
